import { api } from "./base";

export interface Project {
  _id: string;
  name: string;
  key: string;
  description?: string;
  status: "ACTIVE" | "ARCHIVED";
  createdAt: string;
  updatedAt: string;
}

export interface CreateProjectData {
  name: string;
  key: string;
  description?: string;
}

export interface UpdateProjectData {
  name?: string;
  description?: string;
  status?: "ACTIVE" | "ARCHIVED";
}

export interface ListProjectsParams {
  status?: "ACTIVE" | "ARCHIVED";
  search?: string;
  limit?: number;
  offset?: number;
}

export const projectsApi = {
  list: async (params?: ListProjectsParams) => {
    const response = await api.get<{ projects: Project[]; total: number }>(
      "/projects",
      { params },
    );
    return response.data;
  },

  get: async (id: string) => {
    const response = await api.get<Project>(`/projects/${id}`);
    return response.data;
  },

  getByKey: async (key: string) => {
    const response = await api.get<Project>(`/projects/key/${key}`);
    return response.data;
  },

  create: async (data: CreateProjectData) => {
    const response = await api.post<Project>("/projects", data);
    return response.data;
  },

  update: async (id: string, data: UpdateProjectData) => {
    const response = await api.patch<Project>(`/projects/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await api.delete(`/projects/${id}`);
  },
};
